import React from "react";
import { Modal, Icon } from "antd";
import "./confirmModal.css";

const confirm = Modal.confirm;

export const showConfirmSave = obj => {
  confirm({
    title: "Внимание!",
    icon: <Icon type="question-circle" />,
    content: (
      <span>
        Вы действительно хотите сохранить внесенные <br />
        изменения?
      </span>
    ),
    cancelText: "Отмена",
    okText: "Сохранить изменения",
    centered: true,
    className: "blueCustomerCardConfirm",
    ...obj
  });
};

export const showConfirmAddCustomer = obj => {
  confirm({
    title: "Внимание!",
    icon: <Icon type="question-circle" />,
    content: <span>Вы действительно хотите добавить заказчика?</span>,
    cancelText: "Отмена",
    okText: "Добавить заказчика",
    centered: true,
    className: "blueCustomerCardConfirm",
    ...obj
  });
};

export const showConfirmCancelAdding = obj => {
  confirm({
    title: "Внимание!",
    icon: <Icon type="question-circle" />,
    content: (
      <span>
        Вы действительно хотите отменить добавление
        <br />
        Данные будут удалены!
      </span>
    ),
    cancelText: "Отмена",
    okText: "Отменить добавление",
    centered: true,
    className: "warningCustomerCardConfirm",
    ...obj
  });
};

export const showConfirmAbortEdit = obj => {
  confirm({
    title: "Внимание!",
    icon: <Icon type="question-circle" />,
    content: (
      <span>
        Вы действительно хотите отменить редактирование? <br />
        Данные будут удалены!
      </span>
    ),
    cancelText: "Отмена",
    okText: "Отменить изменения",
    centered: true,
    className: "warningCustomerCardConfirm",
    ...obj
  });
};

export const showConfirmBlockCustomer = obj => {
  confirm({
    title: "Внимание!",
    icon: <Icon type="question-circle" />,
    content: (
      <span>
        Вы уверены, что хотите заблокировать заказчика? <br />
        Вход в систему для него будет заблокирован.
      </span>
    ),
    cancelText: "Отмена",
    okText: "Заблокировать",
    centered: true,
    className: "warningCustomerCardConfirm",
    ...obj
  });
};

export const showConfirmArchiveCustomer = obj => {
  confirm({
    title: "Внимание!",
    icon: <Icon type="question-circle" />,
    content: (
      <span>
        Вы уверены, что хотите архивировать заказчика?
        <br />
        Вход в систему для него будет заблокирован.
      </span>
    ),
    cancelText: "Отмена",
    okText: "Архивировать",
    centered: true,
    className: "warningCustomerCardConfirm",
    ...obj
  });
};
